module.exports = __webpack_public_path__ + "棋盘.f5289a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/棋盘.jpg
// module id = 177
// module chunks = 2